import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";

class UOMService {
  allUnitOfMesure(idUser) {
    return api.get(
      UtilsUrl.productionURL() +
        "/units-of-measurement/allUnitOfMesure/" +
        idUser
    );
  }

  addUnitOfMesure(modal) {
    return api.post(
      UtilsUrl.productionURL() + "/units-of-measurement/addUnitOfMesure",
      modal
    );
  }
  getAllCodeUOM(idUserCreation, isDeleted) {
    return api.get(
      UtilsUrl.productionURL() +
        "/units-of-measurement/getAllCodeUOM/" +
        idUserCreation +
        "/" +
        isDeleted
    );
  }
}
export default new UOMService();
